import { ThemeUIStyleObject } from 'theme-ui';
import { CarrotTheme } from '..';

const baseStyles = {
    strong: {
        fontWeight: (theme: CarrotTheme) => theme.fontWeights.bold,
    },
    blockquote: {
        paddingLeft: (theme: CarrotTheme) => theme.space.small,
        borderLeft: (theme: CarrotTheme) => `2px solid ${theme.colors.black10}`,
        margin: '0.75rem 0px 0px',
        color: (theme: CarrotTheme) => theme.colors.black40,
    },
};

const text: Record<string, ThemeUIStyleObject> = {
    ...baseStyles,
};
export default text;
